export default __webpack_public_path__ + "static/media/r-mobile-logo.040d033f.png";